export interface ShortcutData {
  sectionHeader: string
  sectionSubHeader?: string
  shortcuts: Shortcut[]
}

export interface Shortcut {
  description: string
  keys: string[]
  noPlus?: boolean
}

import shortcutData from '@/../shortcuts.json'
import { translateObject } from '@/utils'
export const list = translateObject<Array<ShortcutData>>(shortcutData)
